import { defineMessages } from "react-intl";

export const messages = defineMessages({
  generalTitle: {
    id: 'DKrQj0',
    defaultMessage: "Kit",
    description: "kit detail, card title",
  },
  collection: {
    id: 'v4sHHQ',
    defaultMessage: "Collection",
    description: "kit detail, sidebar label for the collection the kit is built from",
  },
  memberCount: {
    id: 'ewMXKt',
    defaultMessage: "{count, plural, one {# member} other {# members}}",
    description: "kit detail, sidebar member count",
  },
  discountKind: {
    id: 'egzMe9',
    defaultMessage: "Discount type",
    description: "kit detail field",
  },
  discountAmount: {
    id: 'mmTp4K',
    defaultMessage: "Discount",
    description: "kit detail field",
  },
  discountAmountHelp: {
    id: 'YXQrdI',
    defaultMessage: "Taken off the members' own prices.",
    description: "kit detail field help",
  },
  freightClass: {
    id: 'CgcHyb',
    defaultMessage: "Freight class",
    description: "kit detail field",
  },
  freightClassHelp: {
    id: 'hC9sBb',
    defaultMessage: "Leave empty and each member ships on its own freight class.",
    description: "kit detail field help",
  },
  availabilityTitle: {
    id: 'RjPTK+',
    defaultMessage: "Availability",
    description: "kit detail, sidebar card title",
  },
  summaryTitle: {
    id: 'FP3nKP',
    defaultMessage: "Kit summary",
    description: "kit detail, sidebar card title",
  },
  active: {
    id: 'VltWhN',
    defaultMessage: "Sell this collection as a kit",
    description: "kit detail field",
  },
});
